export default "__VITE_ASSET__CJ8U53qV__"